import { Article } from 'interfaces/homepage';

import { PaywallProps } from '@components/Paywall';
import {
  api_articles_recommendation_path,
  api_user_recommended_articles_path,
  paywall_params_api_article_path,
  share_url_api_article_path,
} from '@routes';

import request from './request';

export const ARTICLE_SHARE_KEY = 'article_share';
export const ARTICLE_PAYWALL_PROPS_KEY = 'article_paywall_props';
export const ARTICLES_PROPS_KEY = 'articles_props';

export interface ArticleShareResponse {
  canShareArticle: boolean;
  escapedArticleTitle: string;
  escapedGoLink: string;
  shareUrl: string;
}

export interface ArticlePaywallPropsResponse {
  articleId: number;
  paywallProps: PaywallProps;
}

export async function getArticleShareLink({
  articleId,
}: {
  articleId: number;
}): Promise<ArticleShareResponse> {
  const resp = await request('get', share_url_api_article_path(articleId));
  return resp;
}

export async function getArticlePaywallProps({
  articleId,
  isTwoOptPaywall,
  offerCode,
  shareGuid,
}: Pick<
  PaywallProps,
  'articleId' | 'isTwoOptPaywall' | 'offerCode' | 'shareGuid'
>): Promise<ArticlePaywallPropsResponse> {
  const params = shareGuid
    ? { offer: offerCode, share_guid: shareGuid }
    : { is_two_opt_paywall: isTwoOptPaywall, offer: offerCode };
  const resp = await request('get', paywall_params_api_article_path(articleId, params));
  return resp;
}

interface RecommendedArticlesParams {
  articleSlugs: string[];
}

export async function getRecommendedArticles({
  articleSlugs,
}: RecommendedArticlesParams): Promise<Article[]> {
  const response = await request(
    'get',
    api_articles_recommendation_path({ article_slugs: articleSlugs })
  );
  return response.articles;
}

export async function getUserRecommendedArticles(): Promise<Article[]> {
  const response = await request('get', api_user_recommended_articles_path());
  return response.articles;
}
